export function getAppKey(manifest, appParamsHelper) {
    const { rawAppParams = {} } = appParamsHelper;
    const { configurationKey = 'default', styleKey = 'default', ksysAppTemplateVersion: version = `v${manifest.version}`, applicationCode = '', } = rawAppParams;
    return getAppKeyRaw(manifest.ksysAppTemplateId, configurationKey, styleKey, version, applicationCode);
}
export function getAppKeyRaw(templateId, configurationKey = 'default', styleKey = 'default', version = 'v1.0.0', applicationCode = '') {
    return `${templateId}-${version}|${configurationKey}|${styleKey}${applicationCode.length > 0 ? `|${applicationCode}` : ''}`;
}
//# sourceMappingURL=utils.js.map